import { RoutesPath } from "@ui/navigation/routes";
import { Location } from "react-router";

export const isLocationMatchingRoutes = (location: Location, routes: RoutesPath[]): boolean =>
	routes.some(path =>
		path.includes(":") ? location.pathname.startsWith(path.split(":")[0]) : location.pathname === path,
	);
